/*
 *   File : mandates.js
 *   Author URI : https://evoqins.com
 *   Description : Mandate listing page
 *   Integrations : null
 *   Version : v1.1
 */

import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal } from "bootstrap";

import { DataTableContainer } from "../../../../Components/FormElements";
import { CustomLoader, EmptyScreen } from "../../../../Components/Other";
import { GradientButton, OutlineButton } from "../../../../Components/Cta";
import { CreateMandateModal, UploadSignedMandate, SharePhysicalMandate, DeleteMandate } from "../../../../Components/Modal";
import { CustomTab } from "../../../../Components/Tab";
import { Icon } from "../../../../Components/Icon";
import APIService from "../../../../Services/api-service";

import Colors from "../../../../Styles/color.module.scss";
import { useSelector } from "react-redux";

const MANDATE_TYPE = [
    "E-mandate",
    "Physical mandate"
]

const MandateList = React.memo((props) => {

    const location = useLocation();
    console.log('location', location);
    const params = useParams();
    const customerIdFromUrl = params["*"]; // "11964"
    const customerId = location.state?.user_id || customerIdFromUrl;
    // GET_ADMIN_PROFILE
    const ADMIN_PROFILE_DATA = useSelector(state => state.MT_ADMIN_STORE.ADMIN_PROFILE);

    console.log('ADMIN_PROFILE_DATA', ADMIN_PROFILE_DATA);

    const [mandateList, setMandateList] = useState([]);
    const [loader, setLoader] = useState(true);
    const [showMandateModal, setShowMandateModal] = useState(false);
    const [mandateType, setMandateType] = useState(1);
    const [selectedMandate, setSelectedMandate] = useState("");
    const [openUploadDocModal, setOpenUploadDocModal] = useState(false);
    const [openShareModal, setOpenShareModal] = useState(false);
    const [selectedFormUrl, setSelectedFormUrl] = useState('');
    const [physicalMandateCreationBank, setPhysicalMandateCreationBank] = useState([]);
    const [openMandateListModal, setOpenMandateListModal] = useState(false);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [deleteMandateModal, setDeleteMandateModal] = useState(false);
    const [mandateId, setMandateId] = useState(null);


    useEffect(() => {
        _getMandateList();
    }, [mandateType]);

    useEffect(() => {
        if (showMandateModal === true) {
            const modal = new Modal(document.getElementById("show-mandate"), {});
            modal.show();
        }
    }, [showMandateModal]);

    useEffect(() => {
        if (deleteMandateModal === true) {
            const modal = new Modal(document.getElementById("delete-mandate"), {});
            modal.show();
        }
    }, [deleteMandateModal]);

    useEffect(() => {
        if (openUploadDocModal === true) {
            const modal = new Modal(document.getElementById("upload-mandate"), {});
            modal.toggle();
        }
    }, [openUploadDocModal]);

    useEffect(() => {
        if (openShareModal === true) {
            const modal = new Modal(document.getElementById("share-physical-mandate"), {});
            modal.toggle();
        }
    }, [openShareModal]);

    useEffect(() => {
        if (openMandateListModal === true) {
            _openMandateModal();
        }
    }, [openMandateListModal]);

    const _openMandateModal = () => {
        const modal = new Modal(document.getElementById("show-mandate"), {});
        modal.show();
    }


    function _closeDeleteMandateModal() {
        setDeleteMandateModal(false);
    }

    const _handleCardClick = (row) => {

    }

    const MANDATE_COLUMNS = [
        {
            name: 'Mandate bank',
            selector: row => row['bank_name'],
            sortable: true,
            left: true,
            // width: "576px",
            maxWidth: "200px",
            cell: row =>
                <div className="d-flex align-items-center gap-12px e-fund-name ps-2" onClick={() => _handleCardClick(row)}>
                    <p className="color-primary-color e-poppins-regular e-font-16 line-height-24px mb-0 bg-white mt-0">{row['bank_name']}</p>
                </div>
        },
        {
            name: 'Mandate ID',
            selector: row => row['mandate_id'],
            sortable: false,
            left: true,
            maxWidth: "160px",
            cell: row => <span onClick={() => _handleCardClick(row)}> {row['mandate_id']}</span>,
        },
        {
            name: 'Mandate created on',
            selector: row => row['created'],
            sortable: true,
            left: true,
            maxWidth: "180px",
            cell: row =>
                <p className="color-black e-poppins-regular e-font-16 line-height-24px mb-0 mt-0 gap-12px" onClick={() => _handleCardClick(row)}>
                    {row['created']}
                </p>
        },
        {
            name: 'Mandate expiry date',
            selector: row => row['end_date'],
            sortable: true,
            left: true,
            maxWidth: "180px",
            cell: row => <span onClick={() => _handleCardClick(row)}>
                {row['end_date']}</span>,
        },
        {
            name: 'Mandate limit',
            selector: row => row['mandate_limit'],
            sortable: true,
            left: true,
            maxWidth: "150px",
            cell: row => <span onClick={() => _handleCardClick(row)}>
                <span className="e-inter-regular">₹</span>
                {row['mandate_limit']}</span>,
        },
        {
            name: 'Status',
            selector: row => row['status'],
            sortable: false,
            left: true,
            cell: row =>
                <div onClick={() => _handleCardClick(row)}>
                    <p className={` ${row.status_str === 'SUCCESS' ? 'color-sea-green' : 'color-vivid-orange'} e-poppins-medium e-font-16 line-height-24px mb-0 mt-0 e-mandate-status`}>
                        {row.status_str}
                    </p>
                </div>
        },
        {
            name: 'Remarks',
            selector: row => row['remarks'],
            sortable: false,
            left: true,
            cell: row =>
                <div onClick={() => _handleCardClick(row)}>
                    <p className="color-black e-poppins-regular e-font-16 line-height-24px mb-0 mt-0 gap-12px" onClick={() => _handleCardClick(row)}>
                        {row['remarks'] ? row['remarks'] : '-'}
                    </p>
                </div>
        },
    ];

    const TABLE_STYLE = {
        table: {
            style: {
                padding: "0 16px 16px 16px",
                background: Colors.white,
            },
        },
        tableBody: {
            style: {
                margin: '0px',
                marginTop: "0px !important"
            }
        },
        headRow: {
            style: {
                background: 'transparent',
                borderRadius: "16px 16px 0px 0px",
                border: "0",
                borderBottom: `1px solid ${Colors.bright_gray} !important`,
                fontSize: "14px",
                fontFamily: "Poppins-Medium",
                lineHeight: "24px"
            }
        },
        rows: {
            style: {
                margin: "0",
                background: "transparent",
                border: `1px solid ${Colors.bright_gray} !important`,
                borderRadius: "16px",
                marginTop: "14px",
                fontSize: "16px",
                fontFamily: "Poppins-Regular",
                lineHeight: "24px",
                cursor: "pointer",
                '&:hover': {
                    boxShadow: '0px 12px 16px 0px rgba(50, 50, 71, 0.08)',
                },
            },
        },
        cells: {
            style: {
                '&:not(:last-child)': {
                    paddingLeft: '0px',
                    paddingRight: '0px',
                    display: 'flex',
                    justifyContent: `start !important`
                },
                '&:first-child': {
                    padding: "24px 0px 24px 24px",
                }
            },
        },
        headCells: {
            style: {
                '&:not(:last-child)': {
                    paddingLeft: '0px',
                    paddingRight: '0px',
                    display: 'flex',
                    justifyContent: `start !important`
                },
                '&:first-child': {
                    padding: "24px 0px 24px 24px",
                }
            },
        },
        pagination: {
            style: {
                borderTop: `none `,
                color: Colors.outer_space,
                fontSize: '16px',
                fontFamily: "Poppins-Regular",
            },
        }
    };

    function _handleTab(value) {
        setMandateType(value);
    }

    function _handleMandateUploadButton(id) {
        setSelectedMandate(id);
        setOpenUploadDocModal(true);
    }

    function _handleReSentButton(id, url) {
        setSelectedMandate(id);
        setSelectedFormUrl(url);
        setOpenShareModal(true);
    }

    function _updateMandateStatus() {
        setOpenUploadDocModal(false);
        setSelectedMandate("");
        _getMandateList(2);
    }


    // API - Get user data
    function _getMandateList(type = mandateType) {
        let url = 'v2/mandates/list';
        let payload = JSON.stringify({
            customer_id: customerId,
            bank_id: null,
            mandate_type: type
        });
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                // if (type === 2) {
                //     response.data[0].status_str = "REJECTED";
                // }
                setMandateList(response.data);
            }
            else {
                setMandateList([]);
            }
            setLoader(false);
        })
    }

    // handle create mandate button click
    function _handleMandateButton() {
        setShowMandateModal(true);
    }

    const _closeMandateListModal = () => {
        // setViewMandates(null);
        setOpenMandateListModal(false);
        // setMandateList([]);
    }

    // handler to open mandate modal
    const _showMandateModal = (bank_id = null) => {
        if (bank_id !== null) {
            let bank_data = props.userBank.find(item => item.bank_id === bank_id);

            setPhysicalMandateCreationBank([bank_data]);
        }
        setShowMandateModal(true);
    };



    function _handleDelete(mandate_id) {
        let url = 'mandates/send-otp';
        let payload = JSON.stringify({
            customer_id: customerId,
        });

        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                toast.dismiss();
                toast.success('OTP sent successfully');
                setDeleteMandateModal(true);
                setMandateId(mandate_id);
            } else {
                toast.error(response.message, { type: 'error' });
            }
        });
    };

    const _handleDeleteMandate = (otp) => {
        let url = 'mandates/delete-mandate';
        let payload = JSON.stringify({
            customer_id: customerId,
            "mandate_id": mandateId,
            "otp": otp
        });
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                toast.success('Successfully Deleted ', { type: 'success' });
                if (document.querySelector(".modal-backdrop")) {
                    document.querySelector(".modal-backdrop").remove();
                    document.body.style.overflow = 'unset';
                };
                setDeleteMandateModal(false);
                _getMandateList();
            } else {
                toast.error(response.message, { type: 'error' });
            }
        });
    };

    return (
        <>
            <div className="mt-3">
                <CustomTab data={MANDATE_TYPE}
                    index={mandateType}
                    onSelectTab={_handleTab} />
            </div>
            {
                loader === true ?
                    <div className="h-80vh">

                        <CustomLoader />
                    </div>
                    :
                    mandateList.length !== 0 ?
                        <>
                            {
                                mandateType === 1 ?
                                    <div className="col-12">
                                        {
                                            mandateList.map((item, key) => {
                                                return (
                                                    <div className="col-12 mt-3">

                                                        <div className="border-all border-bright-gray border-radius-16px  overflow-hidden">
                                                            <div className="row gx-0 row-gap-3 pb-3 border-bottom bg-sidebar padding-16px-lr pt-3 ">
                                                                <div className="col-lg-3 col-md-4 col-6 col-12">
                                                                    <div className="d-flex align-items-center gap-12px  ">
                                                                        <div className="p-2 border-radius-8px border-all border-bright-gray e-bank-image">
                                                                            <img src={item.bank_image}
                                                                                alt={item.bank_name}
                                                                                width={28}
                                                                                height={28}
                                                                                className="object-fit-contain" />
                                                                        </div>
                                                                        <p className="e-poppins-medium e-font-14 color-black mb-0">{item.bank_name}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg col-md-4 col-6">
                                                                    <label className="e-poppins-medium e-font-14 color-outer-space">Account holder name</label>
                                                                    <p className="e-poppins-medium e-font-14 color-black mb-0">{item.account_holder_name}</p>
                                                                </div>
                                                                <div className="col-lg col-md-4 col-6">
                                                                    <label className="e-poppins-medium e-font-14 color-outer-space">Account number</label>
                                                                    <p className="e-poppins-medium e-font-14 color-black mb-0">{item.masked_account_number}</p>
                                                                </div>
                                                                <div className="col-lg col-md-4 col-6">
                                                                    <label className="e-poppins-medium e-font-14 color-outer-space">Account Type</label>
                                                                    <p className="e-poppins-medium e-font-14 color-black mb-0">{item.account_type_label}</p>
                                                                </div>
                                                                <div className="col-lg col-md-4 col-6">
                                                                    <label className="e-poppins-medium e-font-14 color-outer-space">IFSC Code</label>
                                                                    <p className="e-poppins-medium e-font-14 color-black mb-0">{item.ifsc_code}</p>
                                                                </div>
                                                            </div>
                                                            {
                                                                item.mandates.length !== 0 ?
                                                                    <>
                                                                        {
                                                                            item.mandates.map((mandate, index) => {
                                                                                return (
                                                                                    <div className="border-bottom padding-16px-lr" key={index}>
                                                                                        <div className="row">
                                                                                            <div className="col-lg col-md-4 col-6 border-lg-right-1px pt-3 pe-4">
                                                                                                <label className="e-poppins-medium e-font-14 color-outer-space">Mandate ID</label>
                                                                                                <p className="e-poppins-medium e-font-14 color-black">{mandate.mandate_id}</p>
                                                                                            </div>
                                                                                            <div className="col-lg col-md-4 col-6 border-lg-right-1px pt-3 pe-4">
                                                                                                <label className={`e-poppins-medium e-font-14 color-outer-space`}>Mandate amt/day</label>
                                                                                                <p className={`e-poppins-medium e-font-14 color-black`}>
                                                                                                    <span className="e-inter-medium me-1">₹</span>
                                                                                                    {mandate.mandate_limit?.toLocaleString('en-IN')}
                                                                                                </p>
                                                                                            </div>
                                                                                            <div className="col-lg col-md-4 col-6 border-lg-right-1px pt-3 pe-4">
                                                                                                <label className="e-poppins-medium e-font-14 color-outer-space">Start date</label>
                                                                                                <p className="e-poppins-medium e-font-14 color-black">{mandate.start_date}</p>
                                                                                            </div>
                                                                                            <div className="col-lg col-md-4 col-6 border-lg-right-1px pt-3 pe-4">
                                                                                                <label className={`e-poppins-medium e-font-14 color-outer-space`}>Expiry date</label>
                                                                                                <p className="e-poppins-medium e-font-14 color-black">{mandate.end_date}</p>
                                                                                            </div>
                                                                                            <div className="col-lg col-md-4 col-6 pt-3 pe-4 border-lg-right-1px">
                                                                                                <label className={`e-poppins-medium e-font-14 color-outer-space`}>Status</label>
                                                                                                <p className={`e-poppins-medium e-font-14 mb-md-0 ${mandate.status_str === 'SUCCESS' ? 'color-sea-green' : mandate.status_str === 'FAILED' ? 'color-red' : 'color-yellow-orange'}`}>{mandate.status_str}</p>
                                                                                            </div>
                                                                                            <div className="col-lg col-md-4 col-6 pt-3 pe-4 border-lg-right-1px">
                                                                                                <label className="e-poppins-medium e-font-14 color-outer-space">Remarks</label>
                                                                                                <p className="e-poppins-medium e-font-14 color-black">{mandate.remarks ? mandate.remarks : '-'}</p>
                                                                                            </div>

                                                                                            <div className="col-lg-2 col-md-4 col-6 pt-3 pe-4">
                                                                                                {ADMIN_PROFILE_DATA?.admin_type_id === 2 &&
                                                                                                    (mandate.status_str === 'PENDING' || mandate.status_str === 'FAILED') && (
                                                                                                        <p
                                                                                                            className={`line-height-16px e-poppins-regular e-font-14 cursor-pointer my-0 ms-3 position-relative h-fit-content
                                                                                                              ${hoveredIndex === index ? 'color-red' : 'color-primary-color'}`}
                                                                                                            onMouseEnter={() => setHoveredIndex(index)}
                                                                                                            onMouseLeave={() => setHoveredIndex(null)}
                                                                                                            onClick={() => _handleDelete(mandate.mandate_id)}
                                                                                                        >
                                                                                                            Delete mandate
                                                                                                            <Icon
                                                                                                                icon={hoveredIndex === index ? 'delete-red' : 'delete'}
                                                                                                                size={24}
                                                                                                                className="ms-1"
                                                                                                            />
                                                                                                        </p>
                                                                                                    )}
                                                                                            </div>
                                                                                        </div>

                                                                                    </div>
                                                                                )
                                                                            })
                                                                        }
                                                                    </>
                                                                    :
                                                                    <div className="col-12 mb-4">
                                                                        <EmptyScreen
                                                                            title={props.userBank.length === 0 ? "User don't have linked any bank" : "Empty mandate data!"}
                                                                            description={''}
                                                                            marginClass="mt-lg-0 mt-4"
                                                                            imageClass="w-105px"
                                                                            secondary={true}
                                                                            buttonLabel={props.userBank.length === 0 ? "" : "Create mandate"}
                                                                            onPress={() => _showMandateModal(item.bank_id)} />
                                                                    </div>
                                                            }
                                                            {
                                                                item.mandates.length ?
                                                                    <div className="row py-4 padding-16px-lr">
                                                                        <div className="col text-center">
                                                                            <OutlineButton label="Create new mandate"
                                                                                className={`${!item.can_create ? 'pointer-events-none opacity-5 padding-8px-tb padding-16px-lr' : 'padding-8px-tb padding-16px-lr'}`}
                                                                                onPress={(e) => _showMandateModal(item.bank_id)} />
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    null
                                                            }
                                                        </div>


                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    :
                                    <div className="row mt-lg-0 mt-md-0 mt-3">
                                        {/* <div className="col-12 mt-3">
                                            <h6 className="e-poppins-medium e-font-16 color-jett-black">Added physical mandate</h6>
                                        </div> */}
                                        {
                                            mandateList.map((item, key) => {
                                                return (
                                                    <div className="col-12 mt-3">

                                                        <div className="border-all border-bright-gray border-radius-16px  overflow-hidden">
                                                            <div className="row gx-0 row-gap-3 pb-3 border-bottom bg-sidebar padding-16px-lr pt-3 ">
                                                                <div className="col-lg-3 col-md-4 col-6 col-12">
                                                                    <div className="d-flex align-items-center gap-12px  ">
                                                                        <div className="p-2 border-radius-8px border-all border-bright-gray e-bank-image">
                                                                            <img src={item.bank_image}
                                                                                alt={item.bank_name}
                                                                                width={28}
                                                                                height={28}
                                                                                className="object-fit-contain" />
                                                                        </div>
                                                                        <p className="e-poppins-medium e-font-14 color-black mb-0">{item.bank_name}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg col-md-4 col-6">
                                                                    <label className="e-poppins-medium e-font-14 color-outer-space">Account holder name</label>
                                                                    <p className="e-poppins-medium e-font-14 color-black mb-0">{item.account_holder_name}</p>
                                                                </div>
                                                                <div className="col-lg col-md-4 col-6">
                                                                    <label className="e-poppins-medium e-font-14 color-outer-space">Account number</label>
                                                                    <p className="e-poppins-medium e-font-14 color-black mb-0">{item.masked_account_number}</p>
                                                                </div>
                                                                <div className="col-lg col-md-4 col-6">
                                                                    <label className="e-poppins-medium e-font-14 color-outer-space">Account Type</label>
                                                                    <p className="e-poppins-medium e-font-14 color-black mb-0">{item.account_type_label}</p>
                                                                </div>
                                                                <div className="col-lg col-md-4 col-6">
                                                                    <label className="e-poppins-medium e-font-14 color-outer-space">IFSC Code</label>
                                                                    <p className="e-poppins-medium e-font-14 color-black mb-0">{item.ifsc_code}</p>
                                                                </div>
                                                            </div>
                                                            {
                                                                item.mandates.length !== 0 ?
                                                                    <>
                                                                        {
                                                                            item.mandates.map((mandate, index) => {
                                                                                return (
                                                                                    <div className="border-bottom padding-16px-lr" key={index}>
                                                                                        <div className="row">
                                                                                            <div className="col-lg col-md-4 col-6 border-lg-right-1px pt-3 pe-4">
                                                                                                <label className="e-poppins-medium e-font-14 color-outer-space">Added on</label>
                                                                                                <p className="e-poppins-medium e-font-14 color-black">{mandate.created}</p>
                                                                                            </div>
                                                                                            <div className="col-lg col-md-4 col-6 border-lg-right-1px pt-3 pe-4">
                                                                                                <label className="e-poppins-medium e-font-14 color-outer-space">End date</label>
                                                                                                <p className="e-poppins-medium e-font-14 color-black">{mandate.end_date}</p>
                                                                                            </div>
                                                                                            <div className="col-lg col-md-4 col-6 border-lg-right-1px pt-3 pe-4">
                                                                                                <label className="e-poppins-medium e-font-14 color-outer-space">Mandate reg. no</label>
                                                                                                <p className="e-poppins-medium e-font-14 color-black">{mandate.mandate_id}</p>
                                                                                            </div>
                                                                                            <div className="col-lg col-md-4 col-6 border-lg-right-1px pt-3 pe-4">
                                                                                                <label className={`e-poppins-medium e-font-14 color-outer-space`}>Mandate limit</label>
                                                                                                <p className={`e-poppins-medium e-font-14 color-black`}>
                                                                                                    <span className="e-inter-medium me-1">₹</span>
                                                                                                    {mandate.mandate_limit?.toLocaleString('en-IN')}
                                                                                                </p>
                                                                                            </div>
                                                                                            <div className="col-lg-1 col-md-4 col-6 border-lg-right-1px pt-3 pe-4">
                                                                                                <label className={`e-poppins-medium e-font-14 color-outer-space`}>Status</label>
                                                                                                <p className={`e-poppins-medium e-font-14 mb-md-0 ${mandate.status_str === 'SUCCESS' ? 'color-sea-green' : mandate.status_str === 'FAILED' ? 'color-red' : 'color-yellow-orange'}`}>{mandate.status_str}</p>
                                                                                            </div>
                                                                                            <div className="col-lg col-md-4 col-6 border-lg-right-1px pt-3 pe-4">
                                                                                                <label className="e-poppins-medium e-font-14 color-outer-space">Remarks</label>
                                                                                                <p className="e-poppins-medium e-font-14 color-black">{mandate.remarks ? mandate.remarks : '-'}</p>
                                                                                            </div>
                                                                                            <div className="col-lg-4 col-md-4 col-sm-6 col-12 pt-3 mb-sm-0 mb-3">
                                                                                                <div className="d-flex mt-0">
                                                                                                    <button className={`${mandate.is_uploaded === false && mandate.status_str !== "REJECTED" ? `border-primary-color cursor-pointer color-primary-color-theme-white` : 'color-old-silver border-old-silver pointer-events-none'} bg-cards e-scan-mandate-file-button border-all border-radius-8px  padding-14px-tb  padding-12px-lr e-poppins-medium e-font-14  d-flex align-items-center justify-content-center w-100 h-max-content`}
                                                                                                        onClick={() => _handleMandateUploadButton(mandate.mandate_id)}>
                                                                                                        <Icon icon="cloud-upload"
                                                                                                            fill={mandate.is_uploaded === false ? Colors.old_sliver : Colors.primary}
                                                                                                            size={18}
                                                                                                            className="me-1" />
                                                                                                        Upload
                                                                                                    </button>
                                                                                                    <OutlineButton label={mandate.upload_file_url !== null ? "Download" : "Re-send form"} //{mandate.is_downloaded === false ? "Download" : "Re-download form"
                                                                                                        disabled={mandate.status_str === "REJECTED" ? true : false}
                                                                                                        className={mandate.status_str === "REJECTED" ? "pointer-events-none ms-3 w-100 opacity-5" : "ms-3 w-100"}
                                                                                                        onPress={() => {
                                                                                                            if (mandate.upload_file_url) {
                                                                                                                window.open(mandate.upload_file_url, "_blank")
                                                                                                            } else {
                                                                                                                _handleReSentButton(mandate.mandate_id, mandate.download_file_url)
                                                                                                            }
                                                                                                        }} />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        {
                                                                                            mandate.is_uploaded === false &&
                                                                                            <div className="row mt-lg-0 mt-3">
                                                                                                <div className="col-12 mb-3">
                                                                                                    <div className="d-md-flex align-items-center justify-content-start">
                                                                                                        <div className="d-flex me-sm-3 align-items-center gap-8px bg-mint-cream p-2 border-radius-8px">
                                                                                                            <div className="w-max-content">
                                                                                                                <Icon icon="info"
                                                                                                                    size={24} />
                                                                                                            </div>
                                                                                                            <p className="e-font-16 e-poppins-regular line-height-24px color-jett-black mb-0 ">
                                                                                                                {`You can upload your signed document on or before ${mandate.start_date}`}
                                                                                                            </p>
                                                                                                        </div>

                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        }

                                                                                        {
                                                                                            (mandate.is_uploaded === true && mandate.status === true && mandate.status_str === 'PENDING') &&
                                                                                            <div className="d-flex gap-8px bg-pale-sky-blue border-radius-32px p-4 my-3">
                                                                                                <div className="w-max-content">
                                                                                                    <Icon icon="info"
                                                                                                        size={30} />
                                                                                                </div>
                                                                                                <div >
                                                                                                    <h6 className="e-poppins-medium e-font-16 color-black">Your physical mandate is under review</h6>
                                                                                                    <p className="e-font-16 e-poppins-regular line-height-24px color-outer-space mb-0 ">In case of fund transfer via Net Banking, payment confirmation may take some time due to Clearing Corporation fund received. Fund transfer via UPI is instant</p>
                                                                                                </div>
                                                                                            </div>
                                                                                        }
                                                                                    </div>
                                                                                )
                                                                            })
                                                                        }
                                                                    </>
                                                                    :
                                                                    <div className="col-12 mb-4">
                                                                        <EmptyScreen
                                                                            // image={NoDataMandate}
                                                                            title="No Physical mandate found"
                                                                            description={''}
                                                                            marginClass="mt-sm-0 mt-4"
                                                                            imageClass="w-105px"
                                                                            secondary={true}
                                                                            buttonLabel="Create physical mandate"
                                                                            // disabled={USER_DATA.is_kyc_done === false ? true : false}
                                                                            onPress={() => _showMandateModal(item.bank_id)} />
                                                                    </div>
                                                            }
                                                            {
                                                                item.mandates.length ?
                                                                    <div className="row py-4 padding-16px-lr">
                                                                        <div className="col text-center">
                                                                            <OutlineButton label="Create new mandate"
                                                                                disabled={!item.can_create}
                                                                                className={`${!item.can_create ? 'pointer-events-none opacity-5 padding-8px-tb padding-16px-lr' : 'padding-8px-tb padding-16px-lr'}`}
                                                                                onPress={(e) => _showMandateModal(item.bank_id)} />
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    null
                                                            }
                                                        </div>


                                                    </div>
                                                )
                                            })
                                        }
                                        {/* <div className="col-12 mt-3">
                                            {console.log(mandateList)}
                                            <GradientButton label="Create new mandate"
                                                className={`${mandateList.some(item => item.is_uploaded === true && item.status === true) &&
                                                    mandateList.every(item => item.status_str !== "REJECTED")
                                                    ? 'color-old-silver bg-chinese-white pointer-events-none'
                                                    : 'bg-prime-gradient color-white'} padding-8px-tb padding-16px-lr`}

                                                onPress={_showMandateModal}
                                            />
                                        </div> */}
                                    </div>
                            }

                        </>
                        :
                        <EmptyScreen title={props.userBank.length === 0 ? "User don't have linked any bank" : "Empty mandate data!"}
                            buttonLabel={props.userBank.length === 0 ? "" : "Create mandate"}
                            secondary={true}
                            onPress={(_handleMandateButton)} />
            }
            {
                showMandateModal === true &&
                <CreateMandateModal userId={customerId}
                    bankData={physicalMandateCreationBank}
                    type={mandateType}
                    updateList={_getMandateList}
                    close={() => setShowMandateModal(false)} />
            }

            {
                openUploadDocModal === true && (
                    <UploadSignedMandate close={() => setOpenUploadDocModal(false)}
                        userId={customerId}
                        mandateId={selectedMandate}
                        updateMandateStatus={_updateMandateStatus} />
                )
            }
            {
                openShareModal === true && (
                    <SharePhysicalMandate close={() => { setOpenShareModal(false); setSelectedFormUrl(""); }}
                        url={selectedFormUrl} />
                )
            }

            {
                deleteMandateModal === true &&
                <DeleteMandate
                    type={2}
                    onResend={_handleDelete}
                    onVerify={(otp) => _handleDeleteMandate(otp)}
                    close={_closeDeleteMandateModal}
                />

            }

        </>
    )
})

export default MandateList